import { toast } from 'react-toastify';
import { Button } from '../../../components/Button';
import { Input } from '../../../components/Input';
import { useEmailToResetPasswordMutation } from '../api/authApi';
import { useState } from 'react';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [resetPassword, { isLoading }] = useEmailToResetPasswordMutation();
  const onSendReset = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      resetPassword({ email }).unwrap();
      toast.success('Success! Check your inbox for further instructions');
      setEmail('');
    } catch (err) {
      toast.error('Something went wrong');
      return err;
    }
  };
  return (
    <div className="max-w-md mx-auto text-center mt-20">
      <h1 className="font-bold mb-8 text-2xl">Forgot password</h1>
      <form className="flex flex-col items-center gap-4" onSubmit={onSendReset}>
        <Input
          label="Email"
          placeholder="E-mail"
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />

        <Button type="submit" isLoading={isLoading} className="w-full mt-4">
          Reset password
        </Button>
      </form>
    </div>
  );
};
